import { Link } from "react-router-dom";

interface Props {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  fullWidth?: boolean;
  size?: "sm" | "md" | "lg";
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}

export default function GoldButton({
  children,
  href,
  onClick,
  fullWidth,
  size = "md",
  disabled = false,
  type,
}: Props) {
  const padding = size === "sm" ? "10px 24px" : size === "lg" ? "20px 48px" : "14px 36px";
  const fontSize = size === "sm" ? 11 : size === "lg" ? 14 : 13;
  const style = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 44,
    background: "#D4A843",
    color: "#050505",
    fontFamily: "'Bebas Neue', sans-serif",
    fontSize,
    letterSpacing: "0.2em",
    padding,
    borderRadius: 3,
    border: "none",
    cursor: disabled ? "not-allowed" : "pointer",
    transition: "background 0.2s ease, opacity 0.2s ease",
    width: fullWidth ? "100%" : "auto",
    textAlign: "center" as const,
    textTransform: "uppercase" as const,
    opacity: disabled ? 0.6 : 1,
  };

  const handleEnter = (e: React.MouseEvent<HTMLElement>) => {
    if (!disabled) {
      e.currentTarget.style.background = "#B8912E";
    }
  };

  const handleLeave = (e: React.MouseEvent<HTMLElement>) => {
    e.currentTarget.style.background = "#D4A843";
  };

  if (href) {
    return (
      <Link to={href} style={style} onMouseEnter={handleEnter} onMouseLeave={handleLeave}>
        {children}
      </Link>
    );
  }

  return (
    <button
      style={style}
      type={type}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
    >
      {children}
    </button>
  );
}
